module.exports = __webpack_public_path__ + "img/Amadeus_Logo.5508707b.png";